// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `input[type=text], textarea {
  border-radius: 30px;
  height: 30px;
  border: 1px solid #ccc;
  width: calc(100% - 7px);
  padding-left: 15px;
}

textarea {
  min-height: 90px;
  width: 99%;
}

button[type=reset] {
  border-radius: 30px;
  height: 36px;
  border: 0;
  width: calc(100% + 17px);
  padding-left: 15px;
  color: white;
  font-size: 10px;
  letter-spacing: 0.1px;
  background-color: #a41f35;
  cursor: pointer;
}

button[type=button] {
  border-radius: 30px;
  height: 36px;
  border: 0;
  width: 55%;
  padding-left: 15px;
  color: white;
  font-size: 10px;
  letter-spacing: 0.1px;
  background-color: #023970;
  cursor: pointer;
}

.pull-right {
  float: right;
}

input[type=date] {
  border-radius: 30px;
  height: 34px;
  border: 1px solid #ccc;
  width: calc(100% + 5px);
  padding-left: 10px;
}

select, .time-control {
  border-radius: 30px;
  height: 34px;
  border: 1px solid #ccc;
  width: calc(100% + 13px);
  padding-left: 10px;
}

.validation-error {
  border: 1px solid #f00 !important;
}

.validation-error-text {
  color: #f00 !important;
}

.time-control {
  width: 100%;
}

::placeholder {
  color: #545454;
}

.row {
  display: flex;
  flex-direction: row;
  width: 100%;
}

.column {
  display: flex;
  flex-direction: column;
  flex: 1 100%;
  margin-right: 20px;
  margin-top: 8px;
}

.table-column {
  display: flex;
  flex-direction: column;
  flex: 1 100%;
  margin-right: 20px;
}

th {
  background-color: #f0f0f0;
  color: #999;
  font-size: 10px;
  font-weight: 600;
  text-align: left;
  padding-top: 15px;
  padding-bottom: 15px;
}

td {
  font-family: "Lato", sans-serif;
  font-size: 11px;
  padding-top: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid #ccc;
}

td:nth-child(1) {
  padding-left: 40px;
}

.resetstyle {
  border-radius: 30px;
  height: 36px;
  border: 0;
  width: calc(100% + 17px);
  padding-left: 15px;
  color: white;
  font-size: 10px;
  letter-spacing: 0.1px;
  background-color: #a41f35 !important;
  cursor: pointer;
}

.loading-spinner {
  display: flex;
  justify-content: center;
}

.progress-spinner {
  position: fixed;
  z-index: 999;
  margin: auto;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.field-label {
  float: left;
  padding-bottom: 10px;
  padding-right: 10px;
  font-weight: bold;
}

.obs-fields-container {
  display: flex;
  flex-direction: column;
}

.contact-fields-container, .alert-and-mileage-fields-container {
  display: flex;
  justify-content: space-between;
}
.contact-fields-container .contact-date-field, .contact-fields-container .contact-type-field, .contact-fields-container .contact-recipient-field,
.contact-fields-container .alert-type-field, .contact-fields-container .alert-description-field, .contact-fields-container .informal-obs-mileage-field, .alert-and-mileage-fields-container .contact-date-field, .alert-and-mileage-fields-container .contact-type-field, .alert-and-mileage-fields-container .contact-recipient-field,
.alert-and-mileage-fields-container .alert-type-field, .alert-and-mileage-fields-container .alert-description-field, .alert-and-mileage-fields-container .informal-obs-mileage-field {
  width: 100%;
}
.contact-fields-container .contact-type-field, .contact-fields-container .alert-description-field, .alert-and-mileage-fields-container .contact-type-field, .alert-and-mileage-fields-container .alert-description-field {
  margin-left: 1rem;
  margin-right: 1rem;
}
.contact-fields-container input, .contact-fields-container select, .contact-fields-container mat-form-field, .alert-and-mileage-fields-container input, .alert-and-mileage-fields-container select, .alert-and-mileage-fields-container mat-form-field {
  width: 100%;
}
.contact-fields-container input[type=date], .alert-and-mileage-fields-container input[type=date] {
  width: calc(100% - 12px);
}

.alert-and-mileage-fields-container {
  margin-top: 1rem;
}
.alert-and-mileage-fields-container textarea {
  width: calc(100% - 18px);
  padding-top: 1rem;
}

.summarySection .summarySection--title {
  font-size: 1.3rem;
  font-weight: bold;
  color: #324758;
  text-transform: uppercase;
  padding: 0.4rem 0 0.6rem 0;
}
.summarySection .summaryItems {
  display: grid;
  grid-template-columns: 1fr 1fr;
}
.summarySection .summaryItems .summary:nth-child(odd) {
  margin-right: 0.8rem;
}
.summarySection .summaryItems .summary:nth-child(even) {
  margin-left: 0.8rem;
}
.summarySection .summaryItems .summary {
  margin-top: 0.7rem;
}
.summarySection .summaryItems .summary .summary--label {
  font-weight: 600;
  display: inline-block;
}
.summarySection .summaryItems .summary .summary--labelHint {
  font-weight: 300;
  display: inline-block;
}
.summarySection .summaryItems .summary .summary--content {
  margin-top: 0.4rem;
}
.summarySection .summaryItems .summary .summary--label-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.summarySection .summaryItems .summary .summary--label {
  flex-grow: 1;
}
.summarySection .summaryItems .summary .reload-button {
  margin-left: 10px;
  width: 220px !important;
  height: 20px;
}
.summarySection .summaryItems .summaryNote .summary--content, .summarySection .summaryItems .summaryOverall .summary--content {
  min-height: 11rem;
}
.summarySection .legend {
  margin-top: 30px;
  margin-bottom: 110px;
}`, "",{"version":3,"sources":["webpack://./src/app/intern/observation/observation-details/observation-details.component.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,YAAA;EACA,sBAAA;EACA,uBAAA;EACA,kBAAA;AACF;;AAEA;EACE,gBAAA;EACA,UAAA;AACF;;AAEA;EACE,mBAAA;EACA,YAAA;EACA,SAAA;EACA,wBAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,qBAAA;EACA,yBAAA;EACA,eAAA;AACF;;AAGA;EACE,mBAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,qBAAA;EACA,yBAAA;EACA,eAAA;AAAF;;AAGA;EACE,YAAA;AAAF;;AAGA;EACE,mBAAA;EACA,YAAA;EACA,sBAAA;EACA,uBAAA;EACA,kBAAA;AAAF;;AAGA;EACE,mBAAA;EACA,YAAA;EACA,sBAAA;EACA,wBAAA;EACA,kBAAA;AAAF;;AAGA;EACE,iCAAA;AAAF;;AAGA;EACE,sBAAA;AAAF;;AAGA;EACE,WAAA;AAAF;;AAGA;EACE,cAAA;AAAF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;AAAF;;AAGA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;AAAF;;AAGA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,kBAAA;AAAF;;AAGA;EACE,yBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;AAAF;;AAGA;EACE,+BAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,6BAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,mBAAA;EACA,YAAA;EACA,SAAA;EACA,wBAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,qBAAA;EACA,oCAAA;EACA,eAAA;AAAF;;AAGA;EACE,aAAA;EACA,uBAAA;AAAF;;AAGA;EACE,eAAA;EACA,YAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AAAF;;AAGA;EACE,WAAA;EACA,oBAAA;EACA,mBAAA;EACA,iBAAA;AAAF;;AAGA;EACE,aAAA;EACA,sBAAA;AAAF;;AAGA;EACE,aAAA;EACA,8BAAA;AAAF;AAEE;;;EAEE,WAAA;AACJ;AAEE;EACE,iBAAA;EACA,kBAAA;AAAJ;AAGE;EACE,WAAA;AADJ;AAIE;EAEE,wBAAA;AAHJ;;AAOA;EACE,gBAAA;AAJF;AAME;EACE,wBAAA;EACA,iBAAA;AAJJ;;AASE;EACE,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,yBAAA;EACA,0BAAA;AANJ;AAQC;EACG,aAAA;EACA,8BAAA;AANJ;AAOI;EACE,oBAAA;AALN;AAOI;EACE,mBAAA;AALN;AAOI;EACE,kBAAA;AALN;AAMM;EACE,gBAAA;EACA,qBAAA;AAJR;AAMM;EACE,gBAAA;EACA,qBAAA;AAJR;AAMM;EACE,kBAAA;AAJR;AAMM;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AAJR;AAOM;EACE,YAAA;AALR;AAQM;EACE,iBAAA;EACA,uBAAA;EACA,YAAA;AANR;AASI;EACE,iBAAA;AAPN;AAWE;EACE,gBAAA;EACA,oBAAA;AATJ","sourcesContent":["input[type=text], textarea {\n  border-radius: 30px;\n  height: 30px;\n  border: 1px solid #ccc;\n  width: calc(100% - 7px);\n  padding-left: 15px;\n}\n\ntextarea {\n  min-height: 90px;\n  width: 99%;\n}\n\nbutton[type=reset] {\n  border-radius: 30px;\n  height: 36px;\n  border: 0;\n  width: calc(100% + 17px);\n  padding-left: 15px;\n  color: white;\n  font-size: 10px;\n  letter-spacing: 0.1px;\n  background-color: #a41f35;\n  cursor: pointer;\n}\n\n\nbutton[type=button] {\n  border-radius: 30px;\n  height: 36px;\n  border: 0;\n  width: 55%;\n  padding-left: 15px;\n  color: white;\n  font-size: 10px;\n  letter-spacing: 0.1px;\n  background-color: #023970;\n  cursor: pointer;\n}\n\n.pull-right {\n  float: right;\n}\n\ninput[type=date] {\n  border-radius: 30px;\n  height: 34px;\n  border: 1px solid #ccc;\n  width: calc(100% + 5px);\n  padding-left: 10px;\n}\n\nselect, .time-control {\n  border-radius: 30px;\n  height: 34px;\n  border: 1px solid #ccc;\n  width: calc(100% + 13px);\n  padding-left: 10px;\n}\n\n.validation-error {\n  border: 1px solid #f00 !important;\n}\n\n.validation-error-text {\n  color: #f00 !important;\n}\n\n.time-control {\n  width: 100%;\n}\n\n::placeholder {\n  color: #545454;\n}\n\n.row {\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n}\n\n.column {\n  display: flex;\n  flex-direction: column;\n  flex: 1 100%;\n  margin-right: 20px;\n  margin-top: 8px;\n}\n\n.table-column {\n  display: flex;\n  flex-direction: column;\n  flex: 1 100%;\n  margin-right: 20px;\n}\n\nth {\n  background-color: #f0f0f0;\n  color: #999;\n  font-size: 10px;\n  font-weight: 600;\n  text-align: left;\n  padding-top: 15px;\n  padding-bottom: 15px;\n}\n\ntd {\n  font-family: 'Lato', sans-serif;\n  font-size: 11px;\n  padding-top: 10px;\n  padding-bottom: 10px;\n  border-bottom: 1px solid #ccc;\n}\n\ntd:nth-child(1) {\n  padding-left: 40px;\n}\n\n.resetstyle {\n  border-radius: 30px;\n  height: 36px;\n  border: 0;\n  width: calc(100% + 17px);\n  padding-left: 15px;\n  color: white;\n  font-size: 10px;\n  letter-spacing: 0.1px;\n  background-color: #a41f35 !important;\n  cursor: pointer;\n}\n\n.loading-spinner {\n  display: flex;\n  justify-content: center;\n}\n\n.progress-spinner {\n  position: fixed;\n  z-index: 999;\n  margin: auto;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n}\n\n.field-label {\n  float: left;\n  padding-bottom: 10px;\n  padding-right: 10px;\n  font-weight: bold;\n}\n\n.obs-fields-container {\n  display: flex;\n  flex-direction: column;\n}\n\n.contact-fields-container, .alert-and-mileage-fields-container {\n  display: flex;\n  justify-content: space-between;\n\n  .contact-date-field, .contact-type-field, .contact-recipient-field,\n  .alert-type-field, .alert-description-field, .informal-obs-mileage-field {\n    width: 100%;\n  }\n  \n  .contact-type-field, .alert-description-field {\n    margin-left: 1rem;\n    margin-right: 1rem;\n  }\n\n  input, select, mat-form-field {\n    width: calc(100%);\n  }\n\n  input[type=date]\n  {\n    width: calc(100% - 12px);\n  }\n}\n\n.alert-and-mileage-fields-container {\n  margin-top: 1rem;\n\n  textarea {\n    width: calc(100% - 18px);\n    padding-top: 1rem;\n  }\n}\n\n.summarySection {\n  .summarySection--title {\n    font-size: 1.3rem; \n    font-weight: bold;\n    color: #324758;\n    text-transform: uppercase;\n    padding: 0.4rem 0 0.6rem 0;\n  }\n .summaryItems {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    .summary:nth-child(odd) {\n      margin-right: 0.8rem;\n    }\n    .summary:nth-child(even) {\n      margin-left: 0.8rem;\n    }\n    .summary {  \n      margin-top: 0.7rem;    \n      .summary--label {\n        font-weight: 600;\n        display: inline-block;\n      }\n      .summary--labelHint {\n        font-weight: 300;\n        display: inline-block;\n      }\n      .summary--content {\n        margin-top: 0.4rem;\n      } \n      .summary--label-container {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n      }\n      \n      .summary--label {\n        flex-grow: 1;\n      }\n      \n      .reload-button {\n        margin-left: 10px;\n        width: 220px !important;\n        height: 20px;\n      }\n    }\n    .summaryNote .summary--content, .summaryOverall .summary--content {\n      min-height: 11rem; \n    }\n  }\n\n  .legend {\n    margin-top: 30px;\n    margin-bottom: 110px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
